import { ChevronRight } from "lucide-react";
import { MatchSetupConfig } from "../../../models/match";
import { Divider } from "../../catalyst/divider";

export const MobilePlayerCard = ({
  player,
  index,
  itemsRef,
  navigate,
  matchSetup,
}: {
  player: any;
  index: number;
  itemsRef: any;
  navigate: any;
  matchSetup?: MatchSetupConfig;
}) => {
  return (
    <div
      key={player.id}
      ref={(el) => {
        if (el) itemsRef.current[player.id] = el;
      }}
      className={`leaderboard-card bg-white dark:bg-gray-800 rounded-lg shadow p-4 cursor-pointer transition-colors duration-200`}
      onClick={() => {
        if (player.isFinalResult) return;
        if (
          matchSetup?.isMatchCompleted &&
          matchSetup?.gameFormat === "matchplay"
        ) {
          return;
        }
        const currentPath = window.location.pathname;
        if (currentPath.startsWith("/currentSeason")) {
          navigate(`/currentSeason/leaderboard/player/${player.id}`);
        } else {
          navigate(`/leaderboard/player/${player.id}`);
        }
      }}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-3">
          {player.profilePicture && (
            <img
              src={`/api/static/images/${player.profilePicture}`}
              alt={`${player.firstName} ${player.lastName}`}
              className="w-12 h-12 rounded-full"
            />
          )}
          <div>
            <div className="font-medium text-gray-900 dark:text-white">
              {player.firstName} {player.lastName}
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <span className="text-lg font-semibold text-gray-900 dark:text-white">
            {matchSetup?.gameFormat === "matchplay" && (
              <div className="flex flex-col items-center">
                {player.matchResult &&
                  player.matchResult.map((mr: any) => {
                    return (
                      <div
                        key={mr.opponentPlayerId}
                        className="flex flex-col items-center"
                      >
                        <p
                          className={`ml-2 text-lg font-semibold text-gray-900 dark:text-white ${
                            mr.matchResult?.includes("up")
                              ? "text-green-600"
                              : mr.matchResult?.includes("down")
                              ? "text-red-600"
                              : "text-blue-600"
                          }`}
                        >
                          {mr.matchResult}
                        </p>
                        {/* <p className="text-sm text-gray-900 dark:text-white">
                          W/L/S: {mr.wins}/{mr.losses}/{mr.draws}
                        </p> */}
                        <p className="text-lg text-gray-900 dark:text-white">
                          vs: {mr.opponent.firstName} {mr.opponent.lastName}
                        </p>
                        {player.matchResult.length > 1 && <Divider />}
                      </div>
                    );
                  })}
                {matchSetup?.groupOrKnockout === "Group" && (
                  <div>
                    <p className="text-sm text-gray-900 dark:text-white">
                      Total Points: {player.totalPoints}
                    </p>
                  </div>
                )}
              </div>
            )}
            {!matchSetup ||
              (matchSetup?.gameFormat !== "matchplay" && (
                <>{player.totalStableford}</>
              ))}
          </span>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
          <span className="mr-4">Sno. #{index + 1}</span>
          <div className="flex items-center">
            {player.playerForTeamLogo && (
              <img
                src={`/api/static/images/${player.playerForTeamLogo}`}
                alt={player.playerForTeamName}
                className="w-5 h-5 rounded-full mr-2"
              />
            )}
            <span>{player.playerForTeamName}</span>
          </div>
        </div>
        {matchSetup?.gameFormat !== "matchplay" && (
          <ChevronRight className="w-5 h-5 text-green-600" />
        )}
      </div>
    </div>
  );
};
